import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'aaSafeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }

  transform(value: string): unknown {
    if (!value) {
      return;
    }
    return this.sanitized.bypassSecurityTrustHtml(value); //NOSONAR
  }
}
